import { render, staticRenderFns } from "./LeaderboardActions.vue?vue&type=template&id=4ca05e40&scoped=true&"
import script from "./LeaderboardActions.vue?vue&type=script&lang=js&"
export * from "./LeaderboardActions.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardActions.vue?vue&type=style&index=0&id=4ca05e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca05e40",
  null
  
)

export default component.exports